import { Collapse } from 'bootstrap'

/**
 * Collapse all items in a container
 * @param {HTMLElement} container - The container element
 */
export const collapseAll = (container) => {
  // Collapse all collapsible elements
  container.querySelectorAll('.collapse').forEach(collapse => {
    const bsCollapse = new Collapse(collapse, { toggle: false })
    bsCollapse.hide()
  })

  // Update all toggle buttons
  updateToggleButtons(container, false)
}

/**
 * Expand only to categories level (first level expanded, second level collapsed)
 * @param {HTMLElement} container - The container element
 */
export const expandToCategories = (container) => {
  container.querySelectorAll('.collapse').forEach(collapse => {
    const button = container.querySelector(`[data-bs-target="#${collapse.id}"]`)
    const isTopLevel = button?.hasAttribute('data-collapse-level-1')

    const bsCollapse = new Collapse(collapse, { toggle: false })
    if (isTopLevel) {
      bsCollapse.show()
      updateToggleButton(button, true)
    } else {
      bsCollapse.hide()
      updateToggleButton(button, false)
    }
  })
}

/**
 * Expand all items in a container
 * @param {HTMLElement} container - The container element
 */
export const expandAll = (container) => {
  // Expand all collapsible elements
  container.querySelectorAll('.collapse').forEach(collapse => {
    const bsCollapse = new Collapse(collapse, { toggle: false })
    bsCollapse.show()
  })

  // Update all toggle buttons
  updateToggleButtons(container, true)
}

/**
 * Update all toggle buttons in a container
 * @param {HTMLElement} container - The container element
 * @param {boolean} expanded - Whether items should appear expanded
 */
const updateToggleButtons = (container, expanded) => {
  container.querySelectorAll('[data-collapse-toggle]').forEach(button => {
    updateToggleButton(button, expanded)
  })
}

/**
 * Update a single toggle button's visual state
 * @param {HTMLElement} button - The toggle button
 * @param {boolean} expanded - Whether the item should appear expanded
 */
const updateToggleButton = (button, expanded) => {
  if (!button) return

  const chevron = button.querySelector('[data-collapse-chevron]')
  if (chevron) {
    if (expanded) {
      chevron.classList.remove('bi-chevron-right')
      chevron.classList.add('bi-chevron-down')
    } else {
      chevron.classList.remove('bi-chevron-down')
      chevron.classList.add('bi-chevron-right')
    }
  }
  button.setAttribute('aria-expanded', expanded.toString())
}

/**
 * Set active state for expand/collapse action buttons
 * @param {HTMLElement} container - The container element
 * @param {string} activeAction - The action that should be marked as active
 */
export const setExpandCollapseActiveButton = (container, activeAction) => {
  const actionButtons = container.querySelectorAll('[data-collapse-action]')

  actionButtons.forEach(btn => {
    const action = btn.getAttribute('data-collapse-action')
    if (action === activeAction) {
      btn.classList.add('active')
    } else {
      btn.classList.remove('active')
    }
  })
}